/* unplugin-vue-components disabled */import script from "./SingleSpecialist.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleSpecialist.vue?vue&type=script&setup=true&lang=js"

import "./SingleSpecialist.vue?vue&type=style&index=0&id=63b69a04&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b69a04"]])

export default __exports__